export class Student {
  user_id: number
  login_id: string
  student_num: number
  name: string
  nendo: number
  grade: number
  room_id: number
  room_name: string
  number: number
  course: number

  constructor(student: any){
    this.user_id = student.user_id;
    this.login_id = student.login_id;
    this.student_num = student.student_num;
    this.name = student.name;
    this.nendo = student.nendo;
    this.grade = student.grade_id;
    this.room_id = student.room_id;
    this.room_name = student.room_name;
    this.number = student.number;
    this.course = student.course;
  }
}

export class SheetResult {
  sheet_group_key: number
  sheet_name: string
  mock_exam_flg: number
  exec_date: string
  score_info: any
  score_bun2_info: any
  goal_score_info: any
  goal_score_bun2_info: any
  room_rank_info: any
  course_rank_info: any
  grade_rank_info: any
  course_deviation_info: any
  grade_deviation_info: any

  constructor(sheet_result: any){
    this.sheet_group_key = sheet_result.sheet_group_key;
    this.sheet_name = sheet_result.sheet_name;
    this.mock_exam_flg = sheet_result.mock_exam_flg;
    this.exec_date = sheet_result.exec_date;
    this.score_info = sheet_result.score_info;
    this.score_bun2_info = sheet_result.score_bun2_info;
    this.goal_score_info = sheet_result.goal_score_info;
    this.goal_score_bun2_info = sheet_result.goal_score_bun2_info;
    this.room_rank_info = sheet_result.room_rank_info;
    this.course_rank_info = sheet_result.course_rank_info;
    this.grade_rank_info = sheet_result.grade_rank_info;
    this.course_deviation_info = sheet_result.course_deviation_info;
    this.grade_deviation_info = sheet_result.grade_deviation_info;
  }
}

export class Curriculum {
  id: number
  name: string
  subjects: Subject[]

  constructor(curriculum: any){
    this.id = curriculum.id;
    this.name = curriculum.name;
    this.subjects = curriculum.subjects.map((x: any) => new Subject(x));
  }
}

export class Subject {
  id: number
  name: string
  subject_num: string

  constructor(subject: any){
    this.id = subject.id;
    this.name = subject.name;
    this.subject_num = subject.subject_num;
  }
}